import { ActivityResponse } from '../models/absorb/activity';
import { apiRequest } from '../utils/axios';

export async function fetchActivities(offset: number): Promise<ActivityResponse> {
  return apiRequest('GET', `/my-activities?_offset=${offset}&_limit=8`);
}
